export default "__VITE_ASSET__CacixT08__"